module.exports = __webpack_public_path__ + "static/media/dolphins_pearl.39487c78.jpg";